export default [
  { name: 'Program name', prop: 'name', type: 'text' },
  { name: 'Show coaches?', prop: 'show_coaches', type: 'checkbox' },
  { name: 'Coach term', prop: 'coach_term', type: 'text' },
  { name: 'Show Join Conversation Button?', prop: 'show_join_conversation_button', type: 'checkbox', default: true },
  { name: 'Initial Comments Required by Coach', prop: 'required_weekly_coach_comments', type: 'number', default: 3 },
  { name: 'Standard Comments Required by Coach', prop: 'required_weekly_coach_comments_override', type: 'number', default: 2 },
  { name: 'Week When Standard Comment Requirement Starts', prop: 'required_weekly_coach_comments_override_start_week', type: 'number', default: 3 }
]
